var _style, _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopBroadcastIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "desktop_broadcast_icon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 172 150",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".desktop_broadcast_icon_svg__st2{fill:none;stroke:#070404;stroke-width:3;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4 42.2l32.7 17c1.2.6 1.2 2.4 0 3l-32.7 17c-1.1.6-2.5-.2-2.5-1.5v-34c0-1.2 1.3-2 2.5-1.5z",
    fill: "#070404",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "desktop_broadcast_icon_svg__st2",
    d: "M159.1 117H12.8c-5.7 0-10.4-4.6-10.4-10.4V12.4C2.4 6.6 7.1 2 12.8 2h146.3c5.7 0 10.4 4.6 10.4 10.4v94.3c-.1 5.7-4.7 10.3-10.4 10.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#070404",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M16.4 15h139v87h-139z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "desktop_broadcast_icon_svg__st2",
    d: "M104.6 117s2.4 22 8.9 22M67 117s-2.2 22-8.6 22M120.9 148H51c-1.1 0-2-.9-2-2v-5c0-1.1.9-2 2-2h69.9c1.1 0 2 .9 2 2v4.9c0 1.2-.9 2.1-2 2.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 85.9,
    cy: 9.5,
    r: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.8 28.5h127v1h-127z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.3,
    cy: 23,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: 23,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.3,
    cy: 23,
    r: 1.5
  }))));
}
export default __webpack_public_path__ + "dd3881dff9628690b0473b471dd306db.svg";
export { SvgDesktopBroadcastIcon as ReactComponent };